import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
  ChangeDetectorRef,
  TemplateRef,
} from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { Router, NavigationStart } from "@angular/router";
import { MessageServiceService } from "src/app/services/message-service.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
//import * as signalR from '@aspnet/signalr';
import { environment } from "src/environments/environment";
import { CommonService } from "src/app/services/common.service";
import { de } from "date-fns/locale";
import { Socket } from "ngx-socket-io";
import { timer, Subject, Subscription, interval } from "rxjs";
import { switchMap } from "rxjs/operators";
import * as signalR from "@aspnet/signalr";
import { InternetConnectivityService } from "src/app/services/internet-connectivity.service";
import {
  GetFeaturesBasedOnRole,
  RoleBasedFeatureModel,
} from "src/app/models/role.model";
import { RoleBasedService } from "src/app/services/role-based.service";

interface Action {
  actionId: number;
  actionName: string;
}

interface MenuItem {
  roleId: number;
  roleName: string;
  featureId: number;
  featureName: string;
  url: string;
  menuIcon: string;
  orderId: number;
  parentId: number;
  menuId: number;
  menuName: string;
  menuFocusId?: string;
  roleXFeatureId?: number;
  actions: Action[];
  subMenu?: MenuItem[];
}

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  //private hubConnection: signalR.HubConnection;
  userData: any;
  onlineMessage;
  confirmModalRef: BsModalRef;
  notificationTitle: string = "Notification Title";
  notificationText: string = "Notification Innertext";
  modelOpen: boolean = false;
  isTimingsShown: boolean = false;
  delayMinutes: string = "0";
  notTimings = [];
  notifier = [];
  defaultRoutingUrl: string = "";
  isForceConnectionClose: boolean = false;
  nconnectionId: string = "";
  internetCheck: boolean = true;
  modalRef?: BsModalRef;
  subscriptions: Subscription[] = [];
  public isInternetConnected: boolean = true;
  public showInternetDisconnectedPopup: boolean = false;
  private beforeUnloadListener: EventListenerOrEventListenerObject;

  @ViewChild("openModal", { static: false }) openModal: TemplateRef<any>;
  @ViewChild("openModalCheckInternet", { static: false })
  openModalCheckInternet: TemplateRef<any>;
  allMenuFeatures: GetFeaturesBasedOnRole[];

  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "my-modal modal-sm",
  };

  closeDropdown()
  {
    this.activeDropdown = null;
  }

  // userData: any = { fullName: 'User Name' }; // This would normally come from your user service
  // defaultRoutingUrl: string = '/dashboard';
  isOffcanvasOpen: boolean = false;
  activeSubmenus: { [key: string]: boolean } = {};

  toggleOffcanvas(): void {
    this.isOffcanvasOpen = !this.isOffcanvasOpen;

    // Toggle body scrolling
    if (this.isOffcanvasOpen) {
      document.body.classList.add("offcanvas-open");
    } else {
      document.body.classList.remove("offcanvas-open");
    }
  }

  toggleSubmenu(submenuId: string): void {
    this.activeSubmenus[submenuId] = !this.activeSubmenus[submenuId];
  }

  isSubmenuOpen(submenuId: string): boolean {
    return this.activeSubmenus[submenuId] === true;
  }

  // logOut(): void {
  //   // Your logout logic here
  //   console.log('Logging out...');
  // }

  timerSub$ = new Subject();
  timerSub: Subscription;
  isLogin:boolean = false;

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private modalService: BsModalService,
    private router: Router,
    private messageService: MessageServiceService,
    private changesDetectRef: ChangeDetectorRef,
    private internetConnectivityService: InternetConnectivityService,
    private roleBasedService: RoleBasedService //private socket: Socket
  ) {
    this.userData = JSON.parse(localStorage.getItem("LOGGED_USER_INFO"));
    if (localStorage.getItem("username") == null) {
      this.router.navigate(["/auth/login"]);
    } else {
      this.userData["adbhuthamUserName"] = localStorage.getItem("username");
    }
    this.notTimings = [
      { value: "5", label: "5 Minutes" },
      { value: "15", label: "15 Minutes" },
      { value: "30", label: "30 Minutes" },
      { value: "45", label: "45 Minutes" },
      { value: "60", label: "60 Minutes" },
    ];
    //this.defaultRoutingUrl = "/base/" + this.userData.defaultURL;
  }

  // public startConnection = async () => {
  //   if (localStorage.getItem('LOGGED_USER_CRMID') != null && +localStorage.getItem('LOGGED_USER_CRMID') > 0 ) {
  //     // ;
  //     // this.hubConnection = new signalR.HubConnectionBuilder()
  //     //   .configureLogging(signalR.LogLevel.Information)
  //     //   .withUrl(environment.notificationEndpoint + "notificationhub")
  //     //   .build();

  //     //   try{
  //     //     await this.hubConnection.start();
  //     //   }
  //     //   catch(e){
  //     //     console.log(e)
  //     //   }
  //     //await this.hubConnection.start();
  //       // .then(() => console.log('Notification Hub Connection started'))
  //       // .catch(err => {
  //       //   console.log('Error while starting connection: ' + err)
  //       //   //setTimeout(() => this.startConnection(),3000)
  //       // })

  //     //this.nconnectionId = await this.hubConnection.invoke('GetConnectionId');

  //     //this.hubConnection.invoke("CheckForNotifications", this.nconnectionId, +localStorage.getItem('LOGGED_USER_CRMID'), new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }).split(',')[0], new Date().getHours() + ':' + new Date().getMinutes());

  //     ;

  //     if(!this.modelOpen){
  //       let payload = await this.hubConnection.invoke("CheckForNotificationsV2", +localStorage.getItem('LOGGED_USER_CRMID'));
  //       this.notificationTitle = "Notification Alert!!!";
  //       let objResponse = JSON.parse(payload)
  //       if (objResponse.IsRecordsExist) {
  //         if(this.openModal && !this.modelOpen){
  //           this.modelOpen = true;
  //           this.notifier = [];
  //           this.notifier.push(objResponse.NotificationInformations);
  //           this.notificationText = objResponse.NotificationText;
  //           this.confirmModalRef = this.modalService.show(this.openModal, Object.assign({}, this.config, { class: 'gray modal-md modal-dialog-centered' }));
  //           this.hubConnection.invoke("AcknowledgeDelivary", objResponse.NotificationInformations.CallbackId, +localStorage.getItem('LOGGED_USER_CRMID'), true);
  //         }
  //         else{
  //           this.hubConnection.invoke("AcknowledgeDelivary", objResponse.NotificationInformations.CallbackId, +localStorage.getItem('LOGGED_USER_CRMID'), false);
  //         }
  //       }
  //     }

  //     // this.hubConnection.on("BroadcastMessage", (type: string, payload: string) => {
  //     //   if (this.openModal && !this.modelOpen) {
  //     //     this.notificationTitle = type;
  //     //     let objResponse = JSON.parse(payload)
  //     //     if (objResponse.IsRecordsExist) {
  //     //       this.modelOpen = true;
  //     //       this.notifier = [];
  //     //       this.notifier.push(objResponse.NotificationInformations);
  //     //       this.notificationText = objResponse.NotificationText;
  //     //       this.hubConnection.invoke("AcknowledgeDelivary", objResponse.NotificationInformations.CallbackId, +localStorage.getItem('LOGGED_USER_CRMID'));
  //     //       this.confirmModalRef = this.modalService.show(this.openModal, Object.assign({}, this.config, { class: 'gray modal-md modal-dialog-centered' }));
  //     //     }
  //     //   }
  //     // });

  //     this.hubConnection.onclose(() => {
  //       if (!this.isForceConnectionClose) {
  //         this.startConnection();
  //       }
  //       else {
  //         console.log('Connection Closed Manually')
  //       }
  //     });
  //   }
  //   else {
  //     this.hubConnection.stop();
  //   }
  // }

  ngOnInit() {
    // this.getScreenPrivileges();
    
    this.preventPageRefresh();
    if (
      localStorage.getItem("LOGGED_USER_CRMID") != null &&
      +localStorage.getItem("LOGGED_USER_CRMID") > 0
    ) {
      //this.startConnection();
    }
    if (localStorage.getItem("LOGGED_USER_CRMID")) {
    }
    this.timerSub = this.timerSub$
      .pipe(switchMap((t: number) => timer(t)))
      .subscribe((res) => {
        if (!this.actionPerformed) {
          if (this.confirmModalRef) this.closeConfirmModal();

          (this.delayMinutes = "10"), (this.isTimingsShown = true);
          this.submitViewAcknowledgement();
        }
      });

    this.beforeUnloadListener = () => {
      // Perform any necessary actions before the page is refreshed
      this.checkSystemInternetConnectivity();
    };

    window.addEventListener("beforeunload", this.beforeUnloadListener);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.checkSystemInternetConnectivity();
      }
    });

    this.isInternetConnected =
      this.internetConnectivityService.isInternetConnected();

    this.internetConnectivityService
      .getInternetStatusChanged()
      .subscribe((isOnline: boolean) => {
        this.isInternetConnected = isOnline;
        if (!isOnline) {
          // Set a timeout before showing the popup
          if (!this.internetConnectivityService.isInternetConnected()) {
            setTimeout(() => {
              this.modalRef = this.modalService.show(
                this.openModalCheckInternet,
                Object.assign({}, this.config, {
                  class: "gray modal-lm modal-dialog-centered",
                })
              );
            }, 50);
            this.internetCheck = false;
            this.onlineMessage =
              "Connection lost, Please check your internet connection.";
          }
        } else {
          setTimeout(() => {
            this.closeModal();
          }, 50);
          this.internetCheck = true;
          this.onlineMessage = "You are connected to internet";
        }
      });

      this.authService.isLogged$.subscribe({
        next: (status: boolean) => {
          if (status) {
            this.isLogin = true;
            this.userData = JSON.parse(localStorage.getItem("LOGGED_USER_INFO"));
            this.getAllFeatures();
            this.getAllMenuFeatures();
          }
          else {
            this.isLogin = false;
          }
        }
      })
  
    // this.commonService.openOutBoundCallPopUp();
  }

  ngOnDestroy(): void {
    //this.internetStatusSubscription.unsubscribe();
    window.removeEventListener("beforeunload", this.beforeUnloadListener);
  }
  activeDropdown: string | null = null;
  
  getReportColumns(subMenu: any[], itemsPerColumn: number = 6): any[][] {
    const columns = [];
    for (let i = 0; i < subMenu.length; i += itemsPerColumn) {
      columns.push(subMenu.slice(i, i + itemsPerColumn));
    }
    return columns;
  }
  

  toggleDropdown(menuName: string) {
    event.preventDefault();
    event.stopPropagation();
    
    // If clicking the already open dropdown, close it
    if (this.activeDropdown === menuName) {
      this.activeDropdown = null;
    } else {
      // Otherwise, open this dropdown (closing any other open one)
      this.activeDropdown = menuName;
    }
  }

  isDropdownActive(menuName: string): boolean {
    return this.activeDropdown === menuName;
  }

  getroutlink(submenuurl:string):string
  {
    return "/base"+submenuurl;
  }

  sideMenuObject: MenuItem[] = [];
  //activeDropdown: string | null = null;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Check if the click is outside the dropdown
    const clickedInsideDropdown = (event.target as HTMLElement).closest('.dropdown');
    if (!clickedInsideDropdown) {
      this.activeDropdown = null;
    }
  }

  private checkInternetConnectivity(): void {
    this.isInternetConnected =
      this.internetConnectivityService.isInternetConnected();
  }

  private checkSystemInternetConnectivity(): void {
    this.isInternetConnected = navigator.onLine;
  }
  navigateToChangePassword() {
    this.router.navigate(["/auth/reset-password"]);
  }

  closeModal() {
    this.modalRef.hide();
    this.modalRef = null;
  }

  ngAfterViewInit() {
    // this.socket.on('reminder', (data) => {
    //   console.log(data);
    //   if (this.openModal) {
    //     this.commonService.getLeadInfoByLeadId(data.alert.leadId)
    //       .subscribe(res => {
    //         ;
    //         this.actionPerformed = false;
    //         this.notifier = [];
    //         if (res.isSuccess) {
    //           this.notificationText = `You are requested to make a call to below patient on ${data.alert.callbackDate} at ${data.alert.callbackTime}`
    //           let tempLead = {
    //             Name: res.response.name,
    //             PhoneNo: res.response.phoneNo,
    //             EmailId: res.response.emailId,
    //             SpecialtyName: res.response.specialityName,
    //             CallbackId: data.alert.requestCallBackId,
    //             Remarks: data.alert.remarks,
    //             UserId: localStorage.getItem('LOGGED_USER_CRMID'),
    //             LeadId: data.alert.leadId,
    //             CallbackDate: data.alert.callbackDate,
    //             CallbackTime: data.alert.callbackTime
    //           };
    //           this.actionPerformed = false;
    //           this.timerSub$.next(60000);
    //           this.notifier.push(tempLead);
    //         }
    //         if (!this.modelOpen) {
    //           this.modelOpen = true;
    //           this.confirmModalRef = this.modalService.show(this.openModal, {
    //             backdrop: 'static',
    //             keyboard: false,
    //             class: 'gray modal-md modal-dialog-centered'
    //           })
    //         }
    //         else {
    //           this.socket.emit('forward', { userId: localStorage.getItem('LOGGED_USER_CRMID'), alert: data.alert }, (err) => {
    //             if (err) {
    //               alert(err)
    //             }
    //           })
    //         }
    //       }, error => {
    //       })
    //   }
    // })
  }
  notificationTimingsClick(ev) {
    this.actionPerformed = true;
  }
  getSubmenuColumns(submenu: any[]): any[][] {
    const itemsPerColumn = Math.ceil(submenu.length / 3);
    const columns: any[][] = [[], [], []];

    submenu.forEach((item, index) => {
      const columnIndex = Math.floor(index / itemsPerColumn);
      if (columnIndex < 3) {
        columns[columnIndex].push(item);
      }
    });

    return columns;
  }

  // public invokeNotification = () => {
  //   this.hubConnection.on("BroadcastMessage", (type: string, payload: string) => {
  //     if (this.openModal && !this.modelOpen) {
  //       this.notificationTitle = type;
  //       let objResponse = JSON.parse(payload)
  //       if (objResponse.IsRecordsExist) {
  //         this.modelOpen = true;
  //         this.notifier = [];
  //         this.notifier.push(objResponse.NotificationInformations);
  //         this.notificationText = objResponse.NotificationText;
  //         this.hubConnection.invoke("AcknowledgeDelivary", objResponse.NotificationInformations.CallbackId, +localStorage.getItem('LOGGED_USER_CRMID'));
  //         this.confirmModalRef = this.modalService.show(this.openModal, Object.assign({}, this.config, { class: 'gray modal-md modal-dialog-centered' }));
  //       }
  //     }
  //   });
  // }

  logOut() {
    localStorage.clear();
    // let data={
    //   "patientMobileNumber":"",
    //   "agentId": ""
    // }
    // localStorage.setItem("CurrentInBoundCallDetails",JSON.stringify(data))
    localStorage.removeItem("CurrentInBoundCallDetails");
    this.authService.isLogged$.next(false);
    this.authService.removeTokens();
    this.changesDetectRef.detectChanges();
    //this.socket.disconnect();
    // if (this.hubConnection !== null) {
    //   this.hubConnection.stop();
    //   this.isForceConnectionClose = true;
    // }

    this.router.navigate(["/auth/login"]);
    //localStorage.removeItem("FeatureActions");
  }

  preventPageRefresh() {
    // window.addEventListener("beforeunload", function (e) {
    //   var confirmationMessage = "\o/";
    //   console.log("cond");
    //   e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
    //   return confirmationMessage;              // Gecko, WebKit, Chrome <34
    // });
  }

  @Output()
  open: EventEmitter<boolean> = new EventEmitter();

  menuOpen = false;
  clickMenu() {
    this.menuOpen = !this.menuOpen;
    this.open.emit(true);
  }

  onClickedOutside(e: Event) {
    if (e.returnValue && this.menuOpen) {
      this.clickMenu();
    }
  }

  // OpenModal(type, ) {
  //   if (this.openModal) {
  //     this.notificationTitle = "Notification Title";
  //     this.confirmModalRef = this.modalService.show(this.openModal, Object.assign({}, this.config, { class: 'gray modal-md modal-dialog-centered' }));
  //   }
  // }

  closeConfirmModal() {
    this.confirmModalRef.hide();
    this.modelOpen = false;
  }

  onCheckboxChange(e) {
    if (e.target.checked) {
      this.isTimingsShown = true;
    } else {
      this.isTimingsShown = false;
    }
  }

  notificationTimeChange(event) {
    this.actionPerformed = true;
    this.delayMinutes = event.value;
  }

  actionPerformed: boolean = false;

  submitViewAcknowledgement() {
    //
    this.actionPerformed = true;
    let payload = {
      IsDelayed: this.isTimingsShown,
      DelayedMinutes: this.delayMinutes,
      CallbackId: this.notifier[0].CallbackId,
      UserId: +localStorage.getItem("LOGGED_USER_CRMID"),
      LeadId: this.notifier[0].LeadId,
      CallbackDate: this.notifier[0].CallbackDate,
      CallbackTime: this.notifier[0].CallbackTime,
      Remarks: this.notifier[0].Remarks,
    };
    if (this.isTimingsShown) {
      if (this.delayMinutes == "0") {
        //this.messageService.showErrorMessage("Select minutes to delay")
        alert("Select minutes to delay");
      } else {
        this.PostAcknowledgement(payload);
        this.closeConfirmModal();
      }
    } else {
      this.PostAcknowledgement(payload);
      this.closeConfirmModal();
    }
  }

  PostAcknowledgement(payload) {
    this.commonService.acknowledgeUserNotificationDelivary(payload).subscribe(
      (res: any) => {
        this.delayMinutes == "0";
        this.isTimingsShown = false;
        console.log("test:", res);
      },
      (error) => {
        // this.messageService.showError();
      }
    );
  }

  makeOutBoundCall(leadInfo) {
    this.actionPerformed = true;
    this.closeConfirmModal();
    let leadData = {
      leadId: leadInfo[0].LeadId,
      firstName: leadInfo[0].FirstName,
      lastName: leadInfo[0].LastName,
      phoneNo: leadInfo[0].PhoneNo,
      patientUHID: "",
      gender: "",
      emailId: leadInfo[0].EmailId,
    };
    console.log("lead11:", leadData);
    localStorage.setItem(
      "CurrentOutBoundCallMobileNumber",
      JSON.stringify(leadData)
    );
    let payload = {
      IsDelayed: this.isTimingsShown,
      DelayedMinutes: "0",
      CallbackId: this.notifier[0].CallbackId,
      UserId: +localStorage.getItem("LOGGED_USER_CRMID"),
      LeadId: this.notifier[0].LeadId,
      CallbackDate: "",
      CallbackTime: "",
    };
    this.PostAcknowledgement(payload);
    this.closeConfirmModal();
    this.commonService.openOutBoundCallPopUp();
  }

  iAmBusy(ev: any) {
    console.log(ev, localStorage.getItem("username"));

    let payload = {
      userId: localStorage.getItem("username"),
      status: !ev,
    };
    this.commonService.updateUserStatus(payload).subscribe((res) => {});
  }

  getAllFeaturesByRoleIdObject: RoleBasedFeatureModel[];
  getAllFeatures() {
    this.roleBasedService.getFeaturesBasedOnRoleId().subscribe(
      (res: any) => {
        if (res.isSuccess) {
          this.getAllFeaturesByRoleIdObject = res.response;
          this.getAllMenuFeatures();
        }
      },
      (error) => {
        console.log("ohhh1");
        this.messageService.showError();
      }
    );
  }

  getAllMenuFeatures() {
    this.roleBasedService.getFeaturesBasedOnRoleId().subscribe(
      (res) => {
        if (res.response.length > 0) this.allMenuFeatures = res.response;
        // console.log('nav main obj: ',this.allMenuFeatures);
        localStorage.setItem("FeatureActions", null);
        localStorage.setItem(
          "FeatureActions",
          JSON.stringify(this.allMenuFeatures)
        );
        // console.log('nav: ',JSON.parse(localStorage.getItem("FeatureActions")));
        this.changesDetectRef.detectChanges();
        this.generateRoleMenuObject(this.allMenuFeatures);
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve side menu data from server "
        );
      }
    );
  }

  // sideMenuObject = [];
  generateRoleMenuObject(menuObj: any[]) {
    this.sideMenuObject = [];

    if (!menuObj || menuObj.length === 0) {
      this.router.navigate(["/base/custom-message"]);
      return;
    }

    // Step 1: Process top-level menus (parentId == 0)
    const parentMenus = menuObj.filter((menu) => menu.parentId === 0);

    parentMenus.forEach((parentMenu) => {
      const menuItem: MenuItem = { ...parentMenu };
      menuItem.menuName =
        menuItem.menuName || menuItem.featureName || "Unnamed Menu";
      menuItem.subMenu = [];

      if (!menuItem.url) {
        console.warn("Missing URL for menu item:", menuItem);
        menuItem.url = "/";
      }

      this.sideMenuObject.push(menuItem);
    });

    // Step 2: Group items by menuId to create dropdown menus
    const menuGroups = menuObj.reduce((groups, item) => {
      if (item.parentId !== 0) {
        const menuId = item.menuId;
        if (!groups[menuId]) {
          groups[menuId] = {
            roleId: item.roleId,
            roleName: item.roleName,
            featureId: null, // No specific feature for parent
            featureName: item.menuName,
            url: null, // Parent menu doesn't need a URL
            menuIcon: item.menuIcon || "fa fa-folder", // Default icon for parent
            orderId: Math.min(
              ...menuObj
                .filter((m) => m.menuId === menuId)
                .map((m) => m.orderId)
            ), // Use min orderId
            parentId: item.parentId,
            menuId: menuId,
            menuName: item.menuName || "Unnamed Menu",
            roleXFeatureId: null,
            actions: [],
            subMenu: [],
          };
        }
        groups[menuId].subMenu.push({ ...item, menuName: item.featureName }); // Use featureName for sub-menu
      }
      return groups;
    }, {});

    // Step 3: Add grouped menus to sideMenuObject
    Object.values(menuGroups).forEach((group: MenuItem) => {
      group.subMenu.sort((a, b) => a.orderId - b.orderId);
      group.menuFocusId = (group.menuName || "").replace(/\s/g, "");

      // Ensure sub-menu items have valid URLs and menuName
      group.subMenu.forEach((subItem) => {
        subItem.menuName = subItem.featureName || "Unnamed Submenu";
        if (!subItem.url) {
          console.warn("Missing URL for submenu item:", subItem);
          subItem.url = "/";
        }
      });

      this.sideMenuObject.push(group);
    });

    // Step 4: Sort top-level menus
    this.sideMenuObject.sort((a, b) => a.orderId - b.orderId);

    // console.log(
    //   "Final Sidemenu Object:",
    //   JSON.stringify(this.sideMenuObject, null, 2)
    // );
  }
}
